<template>
  <div id="main" style="opacity: 1;">
    <!-- header -->
    <app-header />
    <MobileFixedMenu />

    <!-- header end  -->
    <!-- wrapper  -->
    <!-- Breadcrumb Section Start -->
    <section class="breadscrumb-section pt-0">
      <div class="container-fluid-lg">
        <div class="row">
          <div class="col-12">
            <div class="breadscrumb-contain">
              <h1 style="font-size: 18px">
                {{
                  pageTitle
                }}
              </h1>
              <nav>
                <ol class="breadcrumb mb-0">
                  <li class="breadcrumb-item">
                    <router-link to="/">
                      <i class="fa-solid fa-house"></i>
                    </router-link>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    {{ this.$route.params.slug.toUpperCase() }}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Breadcrumb Section End -->

    <!-- Shop Section Start -->
    <section class="section-b-space shop-section">
      <div class="container-fluid-lg">
        <div class="row">
          <div class="col-custome-3 p-2">
            <div class="left-box wow fadeInUp bg-light-gray" ref="sidebar_filters"
                 style="visibility: visible; animation-name: fadeInUp;">
              <div class="shop-left-sidebar vh-100 overflow-scroll" style="scrollbar-width: none;">
                <div class="back-button" @click="toggleSidebarFiltersMenu">
                  <h3><i class="fa-solid fa-arrow-left"></i> Back</h3>
                </div>

                <div class="filter-category">
                  <div class="filter-title">
                    <h2 class="text-theme">Filters</h2>
                    <a href="javascript:void(0)" @click="this.clearFilters">Clear All</a>
                  </div>
                </div>

                <div class="accordion custome-accordion" id="accordionExample">
                  <div class="accordion-item card shadow-lg p-2 w-100" style="margin-left: 10px !important;">
                    <h2 class="accordion-header" id="headingTwo">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span class="text-theme">
                          Sub Categories
                        </span>
                      </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse show" aria-labelledby="headingTwo">
                      <div class="accordion-body">
                        <ul class="category-list custom-padding">
                          <li
                            class="col-12 w-100 row d-flex flex-column">
                            <router-link v-for="category in sub_categories" :key="category"
                                         :title="category?.page_title"
                                         :to="'/listings/categories/'+this.$route.params.slug+'/'+this.$route.params.category_id+'/'+category.slug+'/'+category.id"
                                         class="w-100">
                              <img :src="category?.image_url" alt="" style="height: 20px">
                              {{ category?.name }}
                            </router-link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-2 w-100 mb-2 card p-2 shadow-lg" style="margin-left: 10px !important;"
                       v-for="(field, index) in category_filters" v-loading="loading_filters">
                    <div class="accordion-item">
                      <h2 class="accordion-header" :id="'headingThree'+index">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                :data-bs-target="'#collapseThree'+index" aria-expanded="false"
                                aria-controls="collapseThree">
                          <span class="text-theme">
                            {{ field?.name }}
                          </span>
                        </button>
                      </h2>
                      <div :id="'collapseThree'+index" class="accordion-collapse collapse show"
                           style="max-height: 200px; overflow-y: scroll;scrollbar-width: none;"
                           :aria-labelledby="'headingThree'+index">
                        <div class="accordion-body">
                          <div class="d-flex col justify-space-between align-items-center flex-column">
                            <el-checkbox-group class="col-12 w-100 col"
                                               v-model="category_filters_data">
                              <el-checkbox v-for="value in field?.values" :key="value" :label="value?.id"
                                           class="col w-100">
                                {{
                                  value?.value
                                }}
                              </el-checkbox>
                            </el-checkbox-group>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item card shadow-lg p-2" style="margin-left: 10px !important;">
                    <h2 class="accordion-header" id="headingThree">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                              data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        <span>Price</span>
                      </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse show" aria-labelledby="headingThree">
                      <div class="accordion-body">
                        <div class="d-flex col justify-space-between align-items-center">
                          <input type="text" placeholder="Min Price" class="form-control" v-model="form.min_amount">
                          <span>-</span>
                          <input type="text" placeholder="Max Price" class="form-control" v-model="form.max_amount">
                        </div>
                        <el-button size="large" style="width: 100%" @click="applyPriceFilters"
                                   class="btn btn-outline-primary col mt-1 bg-primary text-white">
                          Apply Price Filter
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-custome-9">
            <div class="filter-button d-inline-block d-lg-none p-2 position-sticky bg-dark shadow-sm w-100"
                 style="top: 5px; z-index: 20 !important; border-radius: 2px"
                 @click="toggleSidebarFiltersMenu">
              <a class="w-100 text-white text-center">
                <i class="fa-solid fa-filter"></i> Filter Menu (Show Filters)<i class="fa-solid fa-angle-right"></i>
              </a>
            </div>
            <div class="show-button">
              <div class="filter-category">
                <div class="category-section-3">
                  <div class="row mt-2">
                    <div class="col-12">
                      <div class="d-flex flex-row" style="overflow: scroll hidden; scrollbar-width: none;">
                        <div class="category-box-list" style="margin-right: 10px; min-width: 170px;"
                             v-for="sub_category in sub_categories">
                          <router-link
                            :title="sub_category?.page_title"
                            :to="'/listings/categories/'+this.$route.params.slug+'/'+this.$route.params.category_id+'/'+sub_category.slug+'/'+sub_category.id"
                            class="w-100">
                            {{ sub_category?.name }}
                          </router-link>
                          <div class="category-box-view">
                            <router-link
                              :title="sub_category?.page_title"
                              :to="'/listings/categories/'+this.$route.params.slug+'/'+this.$route.params.category_id+'/'+sub_category.slug+'/'+sub_category.id"
                              class="w-100">
                              <img
                                :src="sub_category?.image_url"
                                class="img-fluid lazyloaded" :alt="sub_category?.name">
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <ul class="d-flex flex-row justify-content-between">
                  <li @click="removeCategory">
                    <a href="javascript:void(0)">
                      {{ this.$route.params.slug.toUpperCase() }}
                    </a>
                  </li>
                  <el-dropdown @command="handleSortCommand">
                    <span class="el-dropdown-link text-primary">
                      <span class="text-dark">Sort by</span> <span
                      class="fa fa-sort"></span> <span>{{ sort_value }}</span>
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item command="price-asc">Price - Lowest to Highest</el-dropdown-item>
                        <el-dropdown-item command="price-desc">Price - Highest to Lowest</el-dropdown-item>
                        <el-dropdown-item command="date-desc">Most Recent</el-dropdown-item>
                        <el-dropdown-item command="date-asc">Least Recent</el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </ul>
                <div class="search-box mb-2 shadow-sm mt-2 position-sticky" style="position:sticky;top: 100px;">
                  <div class="input-group position-sticky">
                    <div class="col">
                      <form @submit.prevent="searchListings">
                        <div class="input-group">
                          <input type="search" class="form-control" placeholder="I'm searching for..." v-model="search">
                          <button class="btn theme-bg-color text-white" type="submit" id="button-addon2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                 fill="none"
                                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                 class="feather feather-search">
                              <circle cx="11" cy="11" r="8"></circle>
                              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-masonry="masonry" item-selector=".cols" transition-duration="0"
              class="row g-sm-4 g-3 row-cols-xxl-3 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2 product-list-section"
              id="masonry">
              <div v-for="(listing,index) in listings" class="cols" v-masonry-tile>
                <div :key="index"
                     :class="listing?.package?.amount> 0 ? 'product-box-3 wow fadeInUp boosted h-100':'product-box-3 wow fadeInUp h-100'"
                     :data-label="listing?.package?.amount>0?listing?.package?.name:''">
                  <div class="product-header">
                    <div class="product-image">
                      <router-link
                        :to="listing?.link">
                        <img :src="listing?.images?.[0]?.image_url"
                             class="img-fluid blur-up lazyload" :alt="listing?.name + ' image sokoni'">
                      </router-link>
                    </div>
                  </div>
                  <div class="product-footer">
                    <div class="product-detail">
                    <span class="span-name">
                        {{ listing?.category?.name }}
                    </span>
                      <router-link
                        :title="listing?.name + ' - ' + listing?.category?.name + ' - Free Classifieds in Kenya'"
                        :to="listing?.link">
                        <h2 class="name" style="font-size: 16px">
                          {{ listing?.name + ' - ' + listing?.category?.name + ' - Free Classifieds in Kenya' }}
                        </h2>
                      </router-link>
                      <p class="text-content mt-1 mb-2 text-ellipsis">
                        {{ stripHTML(listing?.description) }}
                      </p>
                      <h6 class="unit">
                        {{ listing?.location?.name }}
                      </h6>
                      <h5 class="price">
                        <span class="theme-color">
                            {{ (listing?.currency_price) }}
                        </span>
                      </h5>
                      <div class="add-to-cart-box bg-white"></div>
                    </div>
                  </div>
                </div>
                <div v-if="index % 5 === 0"
                     class="d-none d-md-block product-box-3 wow fadeInUp adsense-ad-desktop">
                  <AdsenseComponentDesktop />
                </div>
                <div v-if="index % 5 === 0"
                     class="d-block d-md-none product-box-3 wow fadeInUp adsense-ad-mobile">
                  <AdsenseComponentMobile />
                </div>
              </div>
            </div>
            <div v-loading="loading" class="col" style="margin-bottom: 5rem;"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- Shop Section End -->
  </div>
</template>
<script>
import AppHeader from '@/components/Sections/Header'
import { mapActions, mapGetters } from 'vuex'
import FeaturedProperties from '@/components/Shared/FeatureProperties'
import SimilarProperties from '@/components/Shared/SimilarProperties'
import GeneralController from '@/mixins/GeneralController'
import MobileFixedMenu from '@/components/Shared/MobileFixedMenu.vue'
import { ElButton, ElCheckbox, ElCheckboxGroup, ElDropdown, ElDropdownItem, ElDropdownMenu } from 'element-plus'
import AdsenseComponentMobile from '@/components/AdsenseComponentMobile.vue'
import AdsenseComponentDesktop from '@/components/AdsenseComponentDesktop.vue'

export default {
  name: 'ListingCategories',
  mixins: [GeneralController],
  components: {
    AdsenseComponentDesktop, AdsenseComponentMobile,
    MobileFixedMenu,
    SimilarProperties,
    FeaturedProperties,
    AppHeader,
    ElCheckbox, ElCheckboxGroup, ElButton, ElDropdown, ElDropdownMenu, ElDropdownItem
  },
  computed: {
    ...mapGetters({
      'listing': 'listings/listing',
      'errors': 'listings/errors',
      'has_errors': 'listings/has_errors',
      'loading': 'listings/loading',
      'categories': 'categories/categories',
      'listings': 'listings/listings',
      'businesses': 'businesses/businesses',
      'last_page': 'listings/last_page',
      'category_filters': 'categories/category_filters',
      'loading_filters': 'categories/loading_filters'
    })
  },
  methods: {
    ...mapActions({
      'getListings': 'listings/getListings',
      'updatePropertyViews': 'listings/updateListingViews',
      'getCategories': 'categories/getCategories',
      'getBusinesses': 'businesses/getBusinesses',
      'getListingsScroll': 'listings/getListingsScroll',
      'getFilters': 'categories/getCategoryFilters'
    }),
    updateUrlSearch() {
      let searchParams = new URLSearchParams(window.location.search)

      searchParams.set('search', this.search)

      if (window.history.replaceState) {
        const url = window.location.protocol
          + '//' + window.location.host
          + window.location.pathname
          + '?'
          + searchParams.toString()

        window.history.replaceState({
          path: url
        }, '', url)
      }
    },

    toggleSidebarFiltersMenu() {
      let menu = this.$refs.sidebar_filters
      if (menu.classList.toString().includes('show')) {
        this.$refs.sidebar_filters.classList.remove('show')
      } else {
        this.$refs.sidebar_filters.classList.add('show')
      }
    },
    clearFilters() {
      this.filters.min_amount = null
      this.filters.max_amount = null
      this.category_filters_data = []
      this.toggleSidebarFiltersMenu()
    },
    applyPriceFilters() {
      if (this.form.min_amount !== '' && this.form.max_amount !== '') {
        this.filters.min_amount = this.form.min_amount
        this.filters.max_amount = this.form.max_amount
      }
      this.toggleSidebarFiltersMenu()
    },
    getSubCategories() {
      let category = this.categories.filter((cat) => Number(cat.id) === Number(this.$route.params.category_id))
      this.sub_categories = category[0].sub_categories
    },
    scroll() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    setPageTitle() {
      let pageTitle = this.$route.params.slug.toUpperCase().replaceAll('-', ' ')
      let subTitle = this.$route.params.sub_category_slug.toLocaleUpperCase().replaceAll('-', ' ') || ''
      let finalTitle = ''
      if (this.search !== '') {
        finalTitle = this.search + ' in ' + (subTitle || pageTitle) + ' for sale in Kenya'
      } else {
        finalTitle = (subTitle || pageTitle) + ' for sale in Kenya'
      }

      document.title = finalTitle
      this.pageTitle = finalTitle
    },
    setCategorySubCategory() {
      let sub_category_id = this.$route.params.sub_category_id
      let category_id = this.$route.params.category_id
      if (sub_category_id !== '' && sub_category_id !== undefined) {
        this.filters.sub_category_id = [sub_category_id]
      }
      if (category_id !== '' && category_id !== undefined) {
        this.filters.listing_category_id = [category_id]
      }
    },
    searchListings(){
      this.setCategorySubCategory()
      this.filters.search = this.search
      this.filters.page = 1
      this.getListings(this.filters)
      this.updateUrlSearch()
      this.setPageTitle()
    }
  },
  mounted() {
    window.onscroll = () => {
      let bottomOfWindow = (document.documentElement.scrollHeight - document.documentElement.scrollTop) - document.documentElement.clientHeight <= 500
      if (!this.loading && Number(this.filters.page) + 1 <= Number(this.last_page)) {
        if (bottomOfWindow) {
          this.filters.page += 1
          this.getListingsScroll(this.filters)
        }
      }
    }
  },
  created() {

    let url = new URL(window.location.href)
    let search = (url.searchParams.get('search'))
    if (search !== undefined && search !== null) {
      this.search = search
      this.filters.search = search
      this.setPageTitle()
      this.updateUrlSearch()
    }

    this.getCategories({}).then(() => {
      this.getSubCategories()
    })
    this.setCategorySubCategory()
    this.getListings({
      ...this.filters,
      'category': this.$route.params.slug,
      'paginate': true,
      reset: true
    })
    this.getFilters(this.filters)
    this.getBusinesses({
      category_id: this.$route.params.category_id,
      'section': 'categories'
    })
    this.setPageTitle()
  },
  data() {
    return {
      search: '',
      booking: {},
      pageTitle: '',
      sub_category_id: [],
      category_filters_data: [],
      filters: {
        page: 1,
        paginate: true,
        per_page: 12,
        listing_category_id: [],
        sub_category_id: []
      },
      sub_categories: [],
      form: {
        listing_category_id: []
      }
    }
  },
  watch: {
    '$route.params.id': {
      deep: true,
      handler: function() {
        let sub_category_id = this.$route.params.sub_category_id
        if (sub_category_id !== '') {
          this.filters.sub_category_id = [sub_category_id]
        }
        this.filters.listing_category_id = [this.$route.params.category_id]
        this.getSubCategories()
        this.getFilters(this.filters)
        this.getListings({
          ...this.filters, 'category': this.$route.params.slug,
          'listing_category_id': [this.$route.params.category_id]
        }).then(() => {
          this.getBusinesses({
            category_id: this.$route.params.category_id,
            'section': 'categories'
          })
          this.setPageTitle()
        })
      }
    },
    category_filters_data: {
      deep: true,
      handler: function() {
        this.setCategorySubCategory()
        this.filters.page = 1
        this.filters.values = this.category_filters_data
        this.getListings(this.filters)
      }
    },
    sub_category_id: {
      deep: true,
      handler: function() {
        this.filters.page = 1
        this.filters.sub_category_id = this.sub_category_id
        this.getListings(this.filters).then(() => {
          this.toggleSidebarFiltersMenu()
        })
      }
    },
  }
}
</script>
<style scoped>
.demo-image__error .image-slot {
  font-size: 30px;
}

.demo-image__error .image-slot .el-icon {
  font-size: 30px;
}

.demo-image__error .el-image {
  width: 100%;
  height: 200px;
}

.custom-form input {
  margin-bottom: 10px;
}

.boosted {
  background: #e3e4f6;
}

.boosted::before {
  position: absolute;
  content: '';
  background: #a86c24;
  height: 18px;
  width: 18px;
  /* Added lines */
  top: 1.2rem;
  right: -0.62rem;
  transform: rotate(45deg);
  z-index: -1 !important;

}

.boosted::after {
  font-weight: bold;
  position: absolute;
  content: attr(data-label);
  top: 4px;
  right: -14px;
  padding: 0.1rem;
  width: auto;
  min-width: 5rem;
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px;
  background: #fcaa3f;
  color: white;
  text-align: center;
  font-family: 'Roboto', sans-serif;
  box-shadow: 4px 4px 15px rgba(26, 35, 126, 0.2);
}

.adsenseOnLeft {
  float: left;
  width: 100% !important;
}
</style>